import type { ReactNode } from 'react'
export function Abbr247({ children }: { readonly children: ReactNode }) {
  return (
    <span aria-label="24 hours a day and 7 days a week" data-testid="Abbr247">
      {children}
    </span>
  )
}
